import script from "./chooseFriend.vue?vue&type=script&setup=true&lang=js"
export * from "./chooseFriend.vue?vue&type=script&setup=true&lang=js"

import "./chooseFriend.vue?vue&type=style&index=0&id=ffb00bbe&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ffb00bbe"]])

export default __exports__